import { Button, InputField } from '@synergy-marine-group/synergy-ui';
import React, { useState } from 'react';

const ApiPagination = ({ setpageNumber, pageNumber,
  totalPages, paginationRowList, handleRowsCount, rowsCount }) => {
  const [pageValue, setpageValue] = useState(pageNumber);
  return (
    <div className="pagination mt-6">
      <Button
        className="bg-primary-500  text-white-DEFAULT "
        variant="filled"
        rounded
        size="medium"
        onClick={() => {
          setpageValue(pageNumber - 1);
          setpageNumber(pageNumber - 1);
        }}
        disabled={pageNumber < 2}
      >
        <div className="text-white-DEFAULT">Previous</div>
      </Button>

      <span className="flex items-center">Page</span>

      <InputField
        className=" w-22 pagination-page-counts"
        id="number"
        defaultValue={1}
        min={1}
        max={totalPages}
        onChange={(e) => {
          if (e.target.value <= totalPages) {
            if (e.target.value >= 0) {
              setpageValue(e.target.value);
            }
          }
        }}
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            setpageNumber(e.target.value > 0 ? Number(e.target.value) : 1);
            setpageValue(e.target.value > 0 ? Number(e.target.value) : 1);
          }
        }}
        onClick={(e) => {
          setpageNumber(e.target.value > 0 ? Number(e.target.value) : 1);
          setpageValue(e.target.value > 0 ? Number(e.target.value) : 1);
        }}
        size="large"
        variant="number"
        rounded
        value={pageValue}
      />

      <span className="flex items-center">
of
        {' '}
{totalPages}
      </span>

      <select
        className=" dropdown-pagination w-full"
        value={rowsCount}
        onChange={(e) => {
          handleRowsCount(e.target.value);
          setpageValue(1);
          setpageNumber(1);
        }}
      >
        {paginationRowList.map((item) => (
          <option key={item} value={item}>
            {item}
{' '}
rows
          </option>
        ))}
      </select>

      <Button
        className="text-white-DEFAULT bg-primary-500"
        variant="filled"
        rounded
        size="medium"
        onClick={() => {
          setpageValue(pageNumber + 1);
          setpageNumber(pageNumber + 1);
        }}
        disabled={pageNumber >= totalPages}
      >
        <div className="text-white-DEFAULT">Next</div>
      </Button>
    </div>
  );
};

export default ApiPagination;
